import { useState } from 'react';
import { useDebounce } from './useDebounce';

type HandleSearch = (value: string) => void;

type UseSearch = (defaultSearch?: string) => {
  handleSearch: HandleSearch;
  /** Debounced — what queries should be keyed on. */
  search?: string;
  /** Undebounced — what a controlled input should display, so typing is not
   *  fought by a value that lags a few hundred milliseconds behind it. */
  searchInput?: string;
};

export const useSearch: UseSearch = (defaultSearch) => {
  /* Stored verbatim and trimmed only on the way out. Trimming on every
     keystroke means a controlled input can never hold a space, so "Cross
     Country" cannot be typed into one. */
  const [searchValue, setSearchValue] = useState(defaultSearch);
  const debouncedSearch = useDebounce(searchValue);

  const handleSearch: HandleSearch = (value) => setSearchValue(value);

  return {
    search: debouncedSearch?.trim(),
    searchInput: searchValue,
    handleSearch
  };
};
